module.exports = __webpack_public_path__ + "img/12220_20.50aa0412.png";